import Vue from 'vue';
import VueRouter from 'vue-router';

// Views
import Login from '../views/Login/Login.vue';
import Calendar from '../views/Calendar/Calendar.vue';
import Meals from '../views/Meals/Meals.vue';
import Shopping from '../views/Shopping/Shopping.vue';
import MyProfile from '../views/MyProfile/MyProfile.vue';
import Join from '../views/Join/Join.vue';
import Bucket from '../views/Bucket/Bucket.vue';
// Admin
import Ingredients from '../views/admin/Ingredients/Ingredients.vue';
// test
import Exec from '../views/test/Exec/Exec.vue';

import * as fb from '../firebase';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/',
    name: 'Calendar',
    component: Calendar,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/meals',
    name: 'Meals',
    component: Meals,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/myProfile',
    name: 'MyProfile',
    component: MyProfile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/shopping',
    name: 'Shopping',
    component: Shopping,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/bucket',
    name: 'NewBucket',
    component: Bucket,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/bucket/:bucketId',
    name: 'Bucket',
    component: Bucket,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/join/:workspaceId',
    name: 'Join',
    component: Join,
  },

  // Admin
  {
    path: '/admin/ingredients',
    name: 'adminIngredients',
    component: Ingredients,
    meta: {
      requiresAdmin: true,
    },
  },

  // Test
  {
    path: '/exec',
    name: 'Exec',
    component: Exec,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// navigation guard to check for logged in users
router.beforeEach(async (to, from, next) => {
  // Admin routes
  const requiresAdmin = to.matched.some((x) => x.meta.requiresAdmin);
  // Auth : admin || requiresAuth
  const requiresAuth =
    requiresAdmin || to.matched.some((x) => x.meta.requiresAuth);

  if (requiresAuth) {
    // Besoin d'être logged
    if (!fb.auth.currentUser) {
      // Non logged
      next('/login');
    } else if (requiresAdmin) {
      // Vérif si admin
      const user = await fb.usersCollection.doc(fb.auth.currentUser.uid).get();
      const userData = user.data();
      if (userData.isAdmin) {
        next();
      } else {
        // On redirige vers la page principale.
        next('/');
      }
    } else {
      // Pas besoin d'être admin, tout est ok
      next();
    }
  } else {
    next();
  }
});

export default router;
